import { stationaryCombustionInputsUK } from './regions/UK-stationary-combustion.input'
import { stationaryCombustionInputsUS } from './regions/US-stationary-combustion.input'

export const stationaryCombustionMapping: { [key: string]: any } = {
  US: stationaryCombustionInputsUS,
  UK: stationaryCombustionInputsUK,
}
